import * as React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { getTranslate } from 'react-localize-redux';
import { withStyles } from '@material-ui/core/styles';

import {
    Dialog, DialogTitle, DialogContent, DialogContentText, DialogActions, Button,
} from '@material-ui/core';

const styles = theme => ({
    actions: {
        padding: theme.spacing(3),
    },
    saveButton: {
        marginLeft: theme.spacing(2),
    },
});

class NavigateDialog extends React.Component {
    render() {
        const {
            classes, translate, open, onCancel, onDiscard, onSave, saveText,
        } = this.props;

        return (
            <Dialog
                open={open}
                onClose={onCancel}
                aria-labelledby="alert-dialog-title"
                aria-describedby="alert-dialog-description"
            >
                <DialogTitle id="alert-dialog-title">{translate('navigateDialog.title')}</DialogTitle>
                <DialogContent>
                    <DialogContentText id="alert-dialog-description">
                        {translate('navigateDialog.description')}
                    </DialogContentText>
                </DialogContent>
                <DialogActions className={classes.actions}>
                    <Button onClick={onCancel}>
                        {translate('navigateDialog.cancel')}
                    </Button>
                    <Button onClick={onDiscard}>
                        {translate('navigateDialog.discardAndNavigate')}
                    </Button>
                    <Button onClick={onSave} variant="contained" color="primary" autoFocus className={classes.saveButton}>
                        {saveText || translate('navigateDialog.saveAndNavigate')}
                    </Button>
                </DialogActions>
            </Dialog>
        );
    }
}

NavigateDialog.propTypes = {
    classes: PropTypes.object.isRequired,
    translate: PropTypes.func.isRequired,
    open: PropTypes.bool.isRequired,
    onCancel: PropTypes.func.isRequired,
    onDiscard: PropTypes.func.isRequired,
    onSave: PropTypes.func.isRequired,
    saveText: PropTypes.string,
};

NavigateDialog.defaultProps = {
    saveText: null,
};


const mapStateToProps = state => ({
    translate: getTranslate(state.localize),
});

export default connect(mapStateToProps)(withStyles(styles)(NavigateDialog));
